import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM8 6c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1m0 4c1.654 0 3-1.346 3-3S9.654 4 8 4 5 5.346 5 7s1.346 3 3 3m-6 8v-2.434l3.972-2.383 2.473 1.649a1 1 0 0 0 1.262-.125l4.367-4.367L18 13.48V18H2zM18 2v8.919l-3.375-2.7a1 1 0 0 0-1.332.074l-4.42 4.42-2.318-1.545a1 1 0 0 0-1.07-.025L2 13.234V2h16z"
});

var SvgImageMajorMonotone = function SvgImageMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgImageMajorMonotone as S };